import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-com-events',
  templateUrl: './com-events.component.html',
  styleUrls: ['./com-events.component.scss']
})
export class ComEventsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
